export const institutionPath = '/uz'

export const hourInMs = 3600000

export const pathsForBanner = ['/for-abiturients/events', '/for-specialists/events']

export const hrefMain = 'https://www.ucheba.ru/'

export const nameUcheba = 'Онлайн-школа Учёба.ру'
